export enum APP_FLAGS {
  USE_NEW_VALIDATION_CARD_RULES = 'enable-cw-onboarding-use-new-validation-card-rules',
  BUSINESS_NAME_ON_SIGNUP_FORM = 'business-name-on-signup-form',
  ENABLE_3DS_VERIFICATION = '3ds-verification-on-sign-up',
  ENABLE_AUTH0_UNIVERSAL_LOGIN = 'enable-auth0-universal-login'
}
